import StateType from './state.type';

export default {
  loading: false,
  contingency: {},
} as StateType;
